// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1___ff7c338653005066a7d","cls2":"SearchBar-cls2__e6725f302a015b63e965 SearchBar-cls1___ff7c338653005066a7d"};